import React from 'react';
import b_ from 'b_';

import I18N from 'assets/i18n/poll-landing';

import './cards.css';

const i18n = I18N.cards;
const b = b_.with('cards');

const Cards = () => {
    return (
        <div className={b()}>
            <ul className={b('scroller')}>
                <li className={b('item')}>
                    <div className={b('title')}>{i18n.card1.title}</div>
                    <div className={b('text')}>{i18n.card1.text}</div>
                </li>
                <li className={b('item')}>
                    <div className={b('title')}>{i18n.card2.title}</div>
                    <div className={b('text')}>{i18n.card2.text}</div>
                </li>
                <li className={b('item')}>
                    <div className={b('title')}>{i18n.card3.title}</div>
                    <div className={b('text')}>{i18n.card3.text}</div>
                </li>
            </ul>
        </div>
    );
};

export default Cards;
